import React from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import moment from 'moment';
import { Form } from 'react-final-form';
import styled from 'styled-components';
import { enterReservation } from '../../../redux/offers';
import { DateAdapter } from '../Create/DateAdapter';
import { FieldWithError } from '../Create/FormAdapters';

declare interface Props {
  attendee: Attendee;
  offer: Offer;
  children: JSX.Element;
  business: Business;
  type: string;
  enterReservation: Function;
}

const Title = styled.div`
  font-family: BrandonGrotesque-Regular;
  font-size: 20px;
  text-align: center;
  font-weight: bold;
  font-style: italic;
  color: var(--color-gunmetal);
  padding-top: 10px;
`;

const ModalButton = styled.button`
  width: 50%;
  height: 40px;
  text-align: center;
  display: inline-block;
  line-height: 40px;
  font-family: BrandonGrotesque-Regular;
  font-size: 18px;
  letter-spacing: 0.2px;
  text-align: center;
  cursor: pointer;
  outline: none !important;
  color: ${(props) => (props.confirm ? '#ffffff' : '#909798')};
  background: ${(props) => (props.confirm ? '#415859' : '#eeeeee')} !important;
`;
const Info = styled.div`
  padding-top: 10px;
  font-family: BrandonGrotesque-Regular;
  font-size: 18px;
  text-align: center;
  color: #555555;
`;

function EnterReservation(props: Props) {
  const id = `enterReservation${props.attendee.id}`;

  const validate = (values: any) => {
    const errors = {} as any;

    if (!values.date) errors.date = 'Please select a date.';
    else {
      const date = moment(values.date);

      if (date.isBefore(moment())) errors.date = 'Date must be in future.';
      else if (date.isAfter(moment().add(60, 'days'))) errors.date = 'Pick a date within 60 days.';
    }

    return errors;
  };

  const handleSubmit = async (values: any) => {
    await props.enterReservation(
      props.attendee.id,
      values.date,
      props.business.business_id,
      props.type
    );
    $('#' + id).modal('hide');
  };

  return (
    <>
      {React.cloneElement(props.children, {
        onClick: () => $('#' + id).modal('show'),
      })}
      <div className="modal fade" id={id} aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content" style={{ width: '352px' }}>
            <div style={{ paddingTop: '10px' }}>
              <Title>Enter Reservation</Title>
              <Info>
                <span>{props.attendee.model.name},</span>
                <br />
                {props.offer.subtitle}
              </Info>
              <Form
                validate={validate}
                onSubmit={handleSubmit}
                initialValues={{ date: props.attendee.reserved_for }}
                render={({ handleSubmit }) => (
                  <form onSubmit={handleSubmit}>
                    <div style={{ padding: '20px' }}>
                      <FieldWithError
                        title="Pick a date"
                        name="date"
                        disabled={false}
                        component={DateAdapter}
                      />
                    </div>
                    <ModalButton
                      type="button"
                      onClick={() => {
                        $(`#${id}`).modal('hide');
                      }}
                    >
                      CANCEL
                    </ModalButton>
                    <ModalButton confirm onClick={() => {}} type="submit">
                      APPLY
                    </ModalButton>
                  </form>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default connect(({ business, offers }: StoreState) => ({ business, offers }), {
  enterReservation,
})(EnterReservation);
